import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=6f385a3f&scoped=true&"
import script from "./MenuSection.vue?vue&type=script&lang=js&"
export * from "./MenuSection.vue?vue&type=script&lang=js&"
import style0 from "./MenuSection.vue?vue&type=style&index=0&id=6f385a3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f385a3f",
  null
  
)

export default component.exports